export function numberWithCommas(number) {
  const parts = number.toString().split('.');
  const commaRegEx = /\B(?=(\d{3})+(?!\d))/g;
  return [parts[0].replace(commaRegEx, ','), ...parts.slice(1)].join('.');
}

export function capitalize(string) {
  return string.toString().split(' ')
        .map(s => s.slice(0, 1).toUpperCase() + s.slice(1))
        .join(' ');
}

export default function format(option) {
  if (!option) {
    return option;
  }
  return isNaN(option) ? capitalize(option) : numberWithCommas(option);
}

export function roundUp(number, step) {
  const diff = number % step;
  return diff ? (number - diff) + step : number;
}

export function roundDown(number, step) {
  const diff = number % step;
  return diff ? number - diff : number;
}

export function toPercent(count, total) {
  const percent = Math.round((count / total) * 100);
  return percent ? `${percent}%` : 'Below 1%';
}

export function splitCamel(word) {
  return word.replace(/([A-Z])/g, ' $1');
}

export function humanizeNumber(input) {
  if (isNaN(input) || input === null) return 'N/A';

  const number = Number.parseFloat(input);

  // Under 1 million, just add commas (ie '435,345')
  if (number < 1000000) return number.toLocaleString();

  // Over one million, "simplify" number (ie '2.3 million')
  const simplified = (number / 1000000).toPrecision(2);
  return `${simplified} million`;
}

export function maxPlus(max, value) {
  let response = numberWithCommas(value);

  if (value >= max) {
    response += '+';
  }

  return response;
}



// WEBPACK FOOTER //
// ./src/utils/format.js